function saveLikedProducts(likes) {
  return new Promise((resolve, reject) => {
    if (CF.customer.id === null) {
      CF.customer.set('product_likes', likes);
      CF.customer.saveAsGuest();
      resolve();
    } else {
      CF.customer.update({ product_likes: likes }).then(resolve).catch(reject);
    }
  });
}

class LikeButton extends HTMLElement {
  constructor() {
    super();

    this.classList.add('is-ready');
    this.CF = window.CF;
    this.likes = this.CF.customer.get('product_likes') || [];
    this.likeButton = this.querySelector('.js-toggle-like');
    this.refresh();
    this.likeButton.addEventListener('click', this.handleLikeClick.bind(this));
  }
  refresh() {
    this.likes = this.CF.customer.get('product_likes') || [];
    if (this.likes.includes(this.likeButton.dataset.likeId)) {
      this.likeButton.classList.add('liked');
    } else {
      this.likeButton.classList.remove('liked');
    }
  }
  changeVariantId(variantId) {
    console.log('changeVariantId', variantId);
    
    if (variantId) {
      this.likeButton.dataset.likeId = this.likeButton.dataset.likeId.split("_")[0] +"_"+ variantId;
      this.refresh();
    }
  }
  handleLikeClick() {
    const likeId = this.likeButton.dataset.likeId;
    const indexOfLikedProduct = this.likes.indexOf(likeId);
    let actionType = 'add';
    
    if (indexOfLikedProduct > -1) {
      this.likes.splice(indexOfLikedProduct, 1);
      //actionType = 'remove';
    } else {
      this.likes.push(likeId);
    }
    this.likeButton.dispatchEvent(
      new CustomEvent('like:update:start', {
        detail: { actionType, id: likeId },
        bubbles: true,
      }),
    );
    saveLikedProducts(this.likes)
      .then(() => {
        this.likeButton.dispatchEvent(
          new CustomEvent('like:update:end', {
            detail: { actionType, likes: this.CF.customer.get('product_likes') },
            bubbles: true,
          }),
        );
      })
      .catch((error) => {
        console.error('Error saving customer data:', error);
      })
      .finally(() => {
        this.refresh();
      });
  }
}
class WishList extends HTMLElement {
  constructor() {
    super();
    this.CF = window.CF;
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.shareButton = this.querySelector('share-button');
    this.grid = this.querySelector('.js-wishlist-grid');
    this.itemClass = this.dataset.itemClass || 'js-liked-product';
    this.init();
    this.setupEventListeners();
  }

  init() {
    this.likes = this.CF.customer.get('product_likes') || [];
    this.grid.innerHTML = "";
    this.classList.remove('is-loaded');
    if (this.CF.customer.id && this.CF.customer.unsavedChanges.product_likes) {
      const mergedLikes = [...new Set([...this.likes, ...this.CF.customer.unsavedChanges.product_likes])];
      saveLikedProducts(mergedLikes)
        .then(() => {
          this.init();
        })
    }
    else if (this.likes.length) {
      this.showSavingOverlay();
      this.likes.map(async (like, i) => {
        const page_url = `${window.location.origin}/products/${like.split('_')[0]}?view=cards-ajax&variant=${like.split('_')[1]}`;
        const response = await fetch(page_url, { method: 'GET' });
        const html = await response.text();
        const htmlDom = new DOMParser().parseFromString(html, 'text/html');
        const likedProduct = htmlDom.querySelector('.'+this.itemClass);
        if (likedProduct) {
          this.grid.appendChild(likedProduct);
        }
        if (i === this.likes.length - 1) {
          this.classList.add('is-loaded');
          this.hideSavingOverlay();
          this.refresh();
        }
      });
    }
    else {
      this.refresh();
    }

  }

  setupEventListeners() {
    // add all to cart
    this.querySelector('.js-atc-all')?.addEventListener('click', this.addAllToCart.bind(this));
    // share wishlist
    this.querySelector('.js-wishlist-share')?.addEventListener('click', this.getWishListLink.bind(this));
    // remove item
    this.addEventListener('like:update:start', () => {
      this.showSavingOverlay();
    });
    this.addEventListener('like:update:end', (e) => {
      document.querySelectorAll('wish-list').forEach((wishList) => {
        wishList.init(e.detail.likes)
      })
      this.hideSavingOverlay();
    });
  }


  refresh() {
    if (!this.CF.customer.get('product_likes') || this.CF.customer.get('product_likes').length == 0) {
      this.classList.add('is-empty');
    } else {
      this.classList.remove('is-empty');
    }
    this.likes = this.CF.customer.get('product_likes') || [];
    console.log(this.likes);
    
    document.querySelectorAll('.js-likes-count').forEach((counter) => {
      counter.innerText = this.likes.length
    });
  }

  hideSavingOverlay() {
    this.querySelector('.saving-overlay-parent')?.classList.remove('saving');
  }
  showSavingOverlay() {
    this.querySelector('.saving-overlay-parent')?.classList.add('saving');
  }

  getWishListLink() {
    const pageUrl = window.location.origin + this.dataset.baseUrl + '/pages/wishlist';
    const likesParams = this.likes.map((like) => `product_likes=${encodeURIComponent(like)}`).join('&');
    const shareableLink = `${pageUrl}?${likesParams}`;
    this.shareButton.updateUrl(shareableLink);
  }

  addAllToCart() {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';

    const items = [];
    this.querySelectorAll('[data-variant-id]').forEach((item) => {
      items.push({
        id: item.dataset.variantId,
        quantity: 1,
      });
    });

    const body = { items };

    if (this.cart) {
      body.sections = this.cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
      this.cart.setActiveElement(document.activeElement);
    }

    config.body = JSON.stringify(body);

    this.showSavingOverlay();
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (this.cart) {
          this.cart.renderContents(response);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        this.hideSavingOverlay();
      });
  }
}

// init wishlist
if (typeof CF !== 'undefined') {
  
  CF.customerReady(async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const sharedLikes = urlParams.getAll('product_likes');
  
    if (sharedLikes.length > 0) {
      const likes = CF.customer.get('product_likes') || [];
      const mergedLikes = [...new Set([...likes, ...sharedLikes])];
      window.history.replaceState( {} , '', window.location.origin+window.location.pathname);
      await saveLikedProducts(mergedLikes);
    }
    customElements.define('like-button', LikeButton);
    customElements.define('wish-list', WishList);
  });
}